
import AppContainer from "@/components/login/LoginContainer.vue";
import AppSection from "@/components/login/LoginSection.vue";
import AppTitle from "@/components/login/LoginTitle.vue";
import AppText from "@/components/login/LoginText.vue";
import AppButton from "@/components/login/LoginButton.vue";
import { AuthService } from "../services/auth-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data(){
		return {
			email: "",
			finished: false
		};
	},
	computed: {
		buttonDisabled():boolean{
			return !this.isValid;
		}
	},
	methods: {
		async resetPassword(){
			if (!this.isValid){
				//return;
			}
			await AuthService.forgotPassword(this.email);
			this.finished = true;
		}
	},
	i18nEx: {
		componentPrefix: "views.TheForgotPassword"
	},
	components: {
		AppContainer,
		AppSection,
		AppTitle,
		AppText,
		AppButton
	},
	mounted(){
		let splashEl = document.getElementById("splash");
		if (!splashEl) return;
		splashEl.remove();
		this.validate();
	}
});
